/* eslint-disable no-console */
import React from 'react';
import {FacialBiometricsHeader, ResponsiveCard, Stepper} from '..';
import {Button, Stack, Typography} from '@mui/material';
import {CTAButtonFixed, IconIllustration} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private';
import {StyledStack} from './styles';
import Icon from 'presentation/icons';
import {AllowCameraProps} from './types';
import {translations} from 'presentation/translations-new';

const {title, description, alert, button} =
	translations['pt-br'].others.facialBiometric.facePhoto.allowCamera;

export function AllowCamera({onAllowCameraAccess}: AllowCameraProps) {
	const {isTablet} = useMediaQueries();

	async function handleAllowCameraAccess() {
		try {
			await navigator.mediaDevices.getUserMedia({video: true});
			onAllowCameraAccess();
		} catch (error: unknown) {
			console.error('Error requesting camera access:', error);
		}
	}

	return (
		<>
			<FacialBiometricsHeader>
				<Stepper activeStep={0} />
			</FacialBiometricsHeader>
			<Stack alignItems="center" height="100%">
				<ResponsiveCard height="100%">
					<Stack alignItems="center" gap={2} height="100%">
						<IconIllustration variant="primary" customIconName="camera" />
						<Typography variant="h6">{title}</Typography>
						<Typography variant="body1" textAlign="center">
							{description}
						</Typography>
						<StyledStack direction="row" alignItems="center" gap={1} mb={1}>
							<Icon name="shield-lock" />
							<Typography variant="body2">{alert}</Typography>
						</StyledStack>
						{!isTablet && <Button onClick={handleAllowCameraAccess}>{button}</Button>}
					</Stack>
				</ResponsiveCard>

				{isTablet && (
					<CTAButtonFixed.Root $isTablet={isTablet} sx={{bottom: 0}}>
						<Stack direction="row" gap={2}>
							<CTAButtonFixed.Action onClick={handleAllowCameraAccess} fullWidth>
								{button}
							</CTAButtonFixed.Action>
						</Stack>
					</CTAButtonFixed.Root>
				)}
			</Stack>
		</>
	);
}
